import * as actions from "./actions";
import * as types from "./types";

import jwt_decode from "jwt-decode";

import { apiCall, TAKER_AUTH_URL, TOKEN_REFRESH_URL } from "apis";
import { POST_LOGIN_IMAGE } from "apis";
import { TakerDeserializer } from "serializers";

import { loadFeedbacks, saveFeedbacks } from "state/modules/feedback";
import { persistState, clearState } from "state/modules/root";
import { forceFetchWifiState } from "state/modules/network";
import { getDeviceName } from "state/modules/app";
import { createError } from "state/modules/error";
import { Navigator } from "router";

export const setSubmittedCount = actions.setSubmittedCount;
export const incrementSubmittedCount = actions.incrementSubmittedCount;

export const login = (username, password, code) => (dispatch, getState) => {
  const { organization } = getState();
  const type = organization.use_2FA ? "2FA" : "";
  dispatch(
    apiCall({
      type: types.POST_LOGIN,
      payload: {
        url: TAKER_AUTH_URL(organization.id),
        data: { username, password, type, code },
        transform: TakerDeserializer,
        onSuccess: onLoginSucces,
        onError: onLoginError,
      },
    }),
  );
};

export const onLoginSucces = taker => async (dispatch, getState) => {
  if (taker.message) {
    dispatch(actions.set2FAasRequired());
    dispatch(
      createError({
        type: types.POST_LOGIN,
        message: taker.message,
      }),
    );
    return;
  }

  dispatch(forceFetchWifiState()); // TODO: fetch wifi state after permission grants
  await dispatch(getDeviceName());

  await dispatch(loadFeedbacks());
  taker.token.exp = jwt_decode(taker.token.digest).exp;
  dispatch(actions.setTaker(taker));
  dispatch(persistState());

  const { organization } = getState();
  if (organization.track_taker_session) {
    Navigator.jumpTo("session");
  } else {
    Navigator.jumpTo("group");
  }
};

export const onLoginError = error => dispatch => {
  dispatch(
    createError({
      type: types.POST_LOGIN,
      message: error.data.detail,
    }),
  );
};

export const logout = () => async dispatch => {
  await dispatch(saveFeedbacks());
  dispatch(clearState());
  Navigator.jumpTo("login");
};

export const refreshToken = () => (dispatch, getState) => {
  const { taker } = getState();
  const { id, token } = taker;

  if (!id) {
    return;
  }

  const now = new Date().getTime() / 1000;
  const dayBefore = token.exp - 24 * 3600;

  if (now < dayBefore) {
    return;
  }

  if (now > token.exp) {
    dispatch(
      createError({
        type: types.POST_TOKEN,
        message: "Your session has expired. Please login again.",
      }),
    );
    return;
  }

  // dayBefore < now < token.exp
  dispatch(
    apiCall({
      type: types.POST_TOKEN,
      payload: {
        url: TOKEN_REFRESH_URL(),
        data: { token: token.digest },
        onSuccess: setToken,
        onDisconnected: () => {},
      },
    }),
  );
};

export const setToken = ({ token: digest }) => dispatch => {
  const { exp } = jwt_decode(digest);
  dispatch(actions.setToken({ digest, exp }));
  dispatch(persistState());
};

export const sendLoginPicture = image => dispatch => {
  const created_at = new Date();
  dispatch(
    apiCall({
      type: types.POST_LOGIN_IMAGE,
      payload: {
        url: POST_LOGIN_IMAGE(),
        data: { image, created_at },
        onSuccess: setSessionId,
      },
    }),
  );
};

const setSessionId = data => dispatch => {
  dispatch(actions.setSessionId(data.id));
  dispatch(persistState());
};

export const clearSessionId = () => dispatch => {
  dispatch(actions.setSessionId(null));
};
